import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpInfoComponent',
  setup(__props) {

const { t } = useI18n()
const text = {
  phone1: t('views.login.phone_1') as string,
  phone2: t('views.login.phone_2') as string,
  help: t('views.login.help') as string,
  writeUs: t('views.login.write_us') as string
}

return { __sfc: true,t, text }
}

})